const normalizeOptionalEnv = (value?: string) => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

const readOptionalEnv = (read: () => string | undefined) => {
  try {
    return normalizeOptionalEnv(read());
  } catch {
    return undefined;
  }
};

export const getOptionalPublicEnv = (read: () => string | undefined) =>
  readOptionalEnv(read);

export const getPublicEnvValue = (key: string): string | undefined =>
  readPublicEnv(key);

export const getPublicSentryDsn = () =>
  readPublicEnv('BUN_PUBLIC_SENTRY_DSN');

export const getPublicAuthToken = () =>
  readPublicEnv('BUN_PUBLIC_AUTH_TOKEN');

export const getPublicUserId = () =>
  readPublicEnv('BUN_PUBLIC_USER_ID');

export const getPublicGoogleClientId = () =>
  readPublicEnv('BUN_PUBLIC_GOOGLE_CLIENT_ID');

export const getPublicCommitSha = () =>
  readPublicEnv('BUN_PUBLIC_COMMIT_SHA');

type ImportMetaWithEnv = ImportMeta & {
  readonly env?: Record<string, string | undefined>;
};

type GlobalWithProcessEnv = typeof globalThis & {
  readonly process?: {
    readonly env?: Record<string, string | undefined>;
  };
};

const readPublicEnv = (key: string): string | undefined => {
  const importMetaEnv = (import.meta as ImportMetaWithEnv).env;
  return normalizeOptionalEnv(
    importMetaEnv?.[key] ?? (globalThis as GlobalWithProcessEnv).process?.env?.[key],
  );
};
